import React, { Fragment } from 'react';
import { withHandlers, withProps, lifecycle, compose, getContext, branch, renderNothing } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { unsetFirstLogin } from '../auth/actions';
import { getFirstLogin } from '../auth/selectors';
import NavExplainer from '../sidebar/navigation/NavExplainer';
import { flagNames, withInjectFeatureFlagsToProps } from '../../modules/infra/feature-flags';

const FirstLoginWelcomeContainer = compose(
  withInjectFeatureFlagsToProps([flagNames.SHOP_ONBOARDING]),
  branch(
    props => props[flagNames.SHOP_ONBOARDING],
    renderNothing,
  ),
  connect(
    state => ({
      firstLogin: getFirstLogin(state),
    }),
    { unsetFirstLogin },
  ),
  withHandlers({
    close: props => () => props.unsetFirstLogin(),
  }),
  getContext({
    toggleSidebar: PropTypes.func.isRequired,
  }),
  withProps(() => ({
    title: 'Welcome to Squire!',
    description: (
      <Fragment>
        For help getting started or general assistance,<br />
        visit the Help Center tab anytime.
      </Fragment>
    ),
  })),
  lifecycle({
    componentDidMount() {
      if (this.props.firstLogin) {
        this.props.toggleSidebar(true);
      }
    },
  }),
)(NavExplainer);

export default FirstLoginWelcomeContainer;
